import React from 'react';
import RetailGrid from './ui/RetailGrid';

function App() {
  return (
    <div className="min-h-screen bg-gray-50/50 flex items-center justify-center py-12">
      <RetailGrid />
    </div>
  );
}

export default App;